
export const isNative = process.env.VUE_APP_IS_NATIVE === 'true'